const normalize = (value) => String(value || '').trim().toLowerCase();

const SUBSCRIPTION_PAYMENT_ACTION_STATUSES = new Set([
  'past_due',
  'unpaid',
  'incomplete',
  'payment_failed',
]);
const VERIFICATION_ACTION_STATUSES = new Set(['pending', 'additional_requested', 'rejected', 'reopened']);

function paymentNeedsCustomerAction(payment) {
  const status = normalize(payment?.status);
  return Boolean(status) && !['paid', 'processing', 'cancelled', 'canceled', 'refunded'].includes(status);
}
function requestPayments(dashboard) {
  const requests = [
    ...(Array.isArray(dashboard?.portal_requests) ? dashboard.portal_requests : []),
    ...(Array.isArray(dashboard?.logistics_requests) ? dashboard.logistics_requests : []),
  ];
  return requests.flatMap((request) => Array.isArray(request?.additional_service_payments)
    ? request.additional_service_payments
    : []);
}

/**
 * Builds a deliberately data-minimal projection from data already authorized
 * for the signed-in customer. It never matches or infers customers itself.
 */
export function buildCustomerDashboardNotices(dashboard = {}) {
  const notices = [];
  const subscriptions = Array.isArray(dashboard.subscriptions) ? dashboard.subscriptions : [];
  const subscriptionPaymentCount = subscriptions.filter((subscription) =>
    SUBSCRIPTION_PAYMENT_ACTION_STATUSES.has(normalize(subscription?.status))
  ).length;
  const additionalPaymentCount = requestPayments(dashboard).filter(paymentNeedsCustomerAction).length;
  const paymentCount = subscriptionPaymentCount + additionalPaymentCount;

  if (paymentCount > 0) {
    notices.push({
      id: 'open-payments', category: 'payment', priority: 1, count: paymentCount,
      messageKey: 'open_payments', actionTab: additionalPaymentCount > 0 ? 'logistics' : 'subscriptions',
    });
  }

  const verifications = Array.isArray(dashboard.verifications) ? dashboard.verifications : [];
  const verificationActionCount = verifications.filter((verification) =>
    VERIFICATION_ACTION_STATUSES.has(normalize(verification?.identity_status))
  ).length;
  if (verificationActionCount > 0) {
    notices.push({
      id: 'verification-action', category: 'account', priority: 2, count: verificationActionCount,
      messageKey: 'verification_action', actionTab: 'verifications',
    });
  }

  const mailCount = Array.isArray(dashboard?.mailbox?.items) ? dashboard.mailbox.items.length : 0;
  if (mailCount > 0) {
    notices.push({
      id: 'new-mail', category: 'mail', priority: 3, count: mailCount,
      messageKey: 'new_mail', actionTab: 'mailbox',
    });
  }

  return notices.sort((left, right) => left.priority - right.priority);
}
